import { useState, useRef } from "react";
import Livret from '../Assets/livret.pdf';
import Handi from '../Assets/handi.pdf';
import CGUr from "../Assets/Conditions Générales d'Utilisation (CGU).pdf";
import CGVr from "../Assets/Conditions Générales de Vente (CGV).pdf";
import LFFr from "../Assets/Livret d'accueil LFF.pdf";
import MAHr from "../Assets/Modalites d'accès handicap.pdf";
import MLr from "../Assets/Mentions Légales.pdf";
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export default function FotterDrop() {
  const [openIndex, setOpenIndex] = useState(2);
  const contentRefs = useRef([]); // Store refs for height calculation

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index); 
  };

  return (
    <div className="w-full">
        <div key={1} className="border-none border-b-2 border-gray-50 rounded-lg shadow-sm w-full">
          <button
            className="w-full text-left py-1 font-semibold hover:text-gray-300 transition-all flex items-center text-white"
            onClick={() => toggleSection(1)}
          >
            <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" />  La Francilienne de la Formation Noisy le Grand
          </button>

          <div
            ref={(el) => (contentRefs.current[1] = el)}
            className="overflow-hidden transition-[height] duration-300 ease-in-out"
            style={{
              height: openIndex === 1 ? `${contentRefs.current[1]?.scrollHeight}px` : "0px",
            }}
          >
                <div>
                        <div key={1} className="px-4 mb-2 text-gray-700">
                            <a href="/ConditionsGeneralsUsers" className='flex items-center justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Conditions générales d'utilisation</p>
                            </a>
                            <a href="/ConditionsGeneralsVente" className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Conditions générales de vente</p>
                            </a>
                            <a href="/MentionLegal" className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Mentions Légales</p>
                            </a>
                            <a href={Livret} className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Livret d'accueil</p>
                            </a>
                            <a href={Handi} className='flex items-start justify-start'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Modalités d'Accès pour les Personnes en Situation de Handicap</p>
                            </a>
                        </div>
                </div>
          </div>
        </div>


        <div key={2} className="border-none border-b-2 border-gray-50 rounded-lg shadow-sm w-full">
          <button
            className="w-full text-left py-1 font-semibold hover:text-gray-300 transition-all flex items-center text-white"
            onClick={() => toggleSection(2)}
          >
            <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" />  La Francilienne de la Formation Rennes 
          </button>

          <div
            ref={(el) => (contentRefs.current[2] = el)}
            className="overflow-hidden transition-[height] duration-300 ease-in-out"
            style={{
              height: openIndex === 2 ? `${contentRefs.current[1]?.scrollHeight}px` : "0px",
            }}
          >
                <div>
                        <div key={2} className="px-4 mb-2 text-gray-700">
                            <a href={CGUr} className='flex items-center justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Conditions générales d'utilisation</p>
                            </a>
                            <a href={CGVr} className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Conditions générales de vente</p>
                            </a>
                            <a href={MLr} className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Mentions Légales</p>
                            </a>
                            <a href={LFFr} className='flex items-start justify-start pb-1'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Livret d'accueil</p>
                            </a>
                            <a href={MAHr} className='flex items-start justify-start'>
                                <ChevronRightIcon className="h-5 text-white stroke-[2px] mr-1" /> 
                                <p className='text-white text-sm'>Modalités d'Accès pour les Personnes en Situation de Handicap</p>
                            </a>
                        </div>
                </div>
          </div>
        </div>
    </div>
  );
}
